export type LcdConnection = 'PARALLEL' | 'I2C';

export interface LcdConfig {
  connection: LcdConnection;
  rs?: string;
  en?: string;
  d4?: string;
  d5?: string;
  d6?: string;
  d7?: string;
  scl?: string;
  sda?: string;
  /** I²C backpack address (hex string like 0x27). */
  i2cAddress: string;
}

export interface OledConfig {
  address: string;
  scl: string;
  sda: string;
  selectablePins: boolean;
}

export interface TftConfig {
  mosi: string;
  miso: string;
  sck: string;
  cs: string;
  dc: string;
  reset: string;
  /** When true, use software SPI constructor with MOSI/SCK. */
  softwareSpi: boolean;
}

export const beginnerDisplayState = {
  lcd: null as LcdConfig | null,
  oled: null as OledConfig | null,
  tft: null as TftConfig | null,
  oledTextSize: 1,
  tftTextSize: 1,
  lcdDeclared: false,
  oledDeclared: false,
  tftDeclared: false,
};

export function resetBeginnerDisplayCodegenState(): void {
  beginnerDisplayState.lcd = null;
  beginnerDisplayState.oled = null;
  beginnerDisplayState.tft = null;
  beginnerDisplayState.oledTextSize = 1;
  beginnerDisplayState.tftTextSize = 1;
  beginnerDisplayState.lcdDeclared = false;
  beginnerDisplayState.oledDeclared = false;
  beginnerDisplayState.tftDeclared = false;
}
